import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react"

import OptionInput from "../OptionInput"
import DateFromToMonthYearInput from "../DateFromToMonthYearInput"

const options = [
    {
        title: "Select",
        key: "",
    },
    {
        title: "Yes",
        key: "yes",
    },
    {
        title: "No",
        key: "no",
    },
]

const CurrentlyEmployedAndConsentInput = forwardRef(({ title, data, readOnly }, ref) => {

    const fieldData = data || {
        currentlyEmployed: options[0].key,
        consentContactCurrentEmployer: options[0].key,
    }

    const [optionCurrentlyEmployed, setOptionCurrentlyEmployed] = useState(fieldData.currentlyEmployed)
    const [optionOkToContactEmployer, setOptionOkToContactEmployer] = useState(fieldData.consentContactCurrentEmployer)

    const currentlyEmployedRef = useRef()
    const consentContactCurrentEmployerRef = useRef()
    const dateFromToRef = useRef()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const currentlyEmployedResult = currentlyEmployedRef.current.validateAndGetData()
            const consentContactCurrentEmployerData = consentContactCurrentEmployerRef.current?.validateAndGetData()
            const dateFromToData = dateFromToRef.current.validateAndGetData()

            return {
                isValid: currentlyEmployedResult.isValid &&
                    (consentContactCurrentEmployerData?.isValid ?? true) &&
                    dateFromToData.isValid,
                value: {
                    currentlyEmployed: currentlyEmployedResult.value,
                    consentContactCurrentEmployer: consentContactCurrentEmployerData?.value,
                    dateFromTo: dateFromToData.value
                },
            }
        },
    }))



    return (
        <div className="my-4">

            <OptionInput
                ref={currentlyEmployedRef}
                data={fieldData.currentlyEmployed}
                options={options}
                title={"Currently Employed by this Company?"}
                valueChangeHandler={setOptionCurrentlyEmployed}
                readOnly={readOnly}
            />
            <OptionInput
                ref={consentContactCurrentEmployerRef}
                data={fieldData.consentContactCurrentEmployer}
                options={options}
                title={"May we contact Employer?"}
                valueChangeHandler={setOptionOkToContactEmployer}
                readOnly={readOnly}
                isMandatory={optionCurrentlyEmployed === "yes"}
            />

            <DateFromToMonthYearInput
                title={""}
                ref={dateFromToRef}
                data={fieldData.dateFromTo}
                readOnly={readOnly}
                toFinalValue={optionCurrentlyEmployed === "yes" ? "now" : null}
                maxFutureYearsFromNow={0}
            />

        </div>
    )
})

export default CurrentlyEmployedAndConsentInput
